export default __webpack_public_path__ + "static/media/arrows-mobile.46a018b1.svg";